package devxertech.com.pages.portfolio.zone

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img

@Composable
fun CommonAppView(image: String, breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxWidth()
            .padding(top = if (breakpoint < Breakpoint.MD) 30.px else 50.px,
                bottom = if (breakpoint < Breakpoint.MD) 20.px else 50.px)
    ) {
        Box(
            modifier = Modifier.fillMaxWidth()
                .backgroundColor(sitePalette.careerPage.rgb),
            contentAlignment = Alignment.TopCenter
        ) {
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(
                        top = if (window.screen.width >= 1600) 50.px else 30.px,
                        bottom = if (window.screen.width >= 1600) 30.px else 0.px
                    ),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "APP",
                    color = sitePalette.primary.rgb,
                    fontSize = if (breakpoint <= Breakpoint.MD) 25.px else if (window.screen.width >= 1600) 70.px else 50.px,
                    marginTop = 10.px,
                    fontWeight = 700,
                )
                FieldTitleTextNormalSimple(
                    " VIEW",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = if (breakpoint <= Breakpoint.MD) 25.px else if (window.screen.width >= 1600) 70.px else 50.px,
                    marginTop = 10.px,
                    fontWeight = 700
                )
            }

            Box(
                modifier = Modifier.fillMaxWidth().padding(
                    top = if (breakpoint < Breakpoint.MD) 100.px
                    else if (window.screen.width >= 1600) 233.px else 150.px,
                    bottom = 50.px
                ),
                contentAlignment = Alignment.Center
            ) {
                Img(src = image) {
                    attr("width", if (window.screen.width > 375) "63%" else "90%")
                    attr("loading", "eager")
                }
            }
        }
    }
}
